import { render } from "./distributionLogInnerPage.vue?vue&type=template&id=25b52328&scoped=true"
import script from "./distributionLogInnerPage.vue?vue&type=script&lang=js"
export * from "./distributionLogInnerPage.vue?vue&type=script&lang=js"

import "./distributionLogInnerPage.vue?vue&type=style&index=0&id=25b52328&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b52328"]])

export default __exports__